import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleFetchSummary(action) {
  try {
  
    
    const { filtersString, view } = action.payload || {};
    const response = yield call(API.fetchCommodityAnalyticsSummary, { 
      filtersString,
      view 
    });
    
    yield put(actions.fetchSummarySuccess(response.data));
  } catch (error) {
    console.error("❌ Summary saga error:", error);
    yield put(actions.fetchSummaryFailure(error.message || "Unknown error"));
  }
}

export function* commodityAnalyticsSummarySaga() {

  yield takeLatest(actions.fetchSummary.type, handleFetchSummary);
}


export const SUMMARY_SAGA_KEY = "commodityAnalyticsSummary";